import firebase from "firebase/compat/app"

export default async () => {
  await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
}
